export default "__VITE_ASSET__D5SD$JDQ__"